import { render, staticRenderFns } from "./40.vue?vue&type=template&id=4c30799b&scoped=true&"
var script = {}
import style0 from "./40.vue?vue&type=style&index=0&id=4c30799b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30799b",
  null
  
)

export default component.exports